<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.01217V1.65208C0.052185 0.967478 0.54096 0.498443 1.16205 0.490028H5.52214C6.10053 0.499718 6.6393 0.708968 7.11158 0.994223L13.9446 8.49953C14.3566 9.0286 14.3778 9.68699 13.9446 10.1322L8.89305 15.1646C8.38262 15.605 7.66725 15.6449 7.26042 15.1646L0.82593 8.00014C0.37362 7.44035 0.006705 6.70352 0 6.01217ZM2.20407 4.2835C2.68662 4.7284 3.3792 4.68724 3.79348 4.2835C4.23637 3.80503 4.19939 3.10523 3.79348 2.69408C3.31438 2.25796 2.61667 2.29256 2.20407 2.69408C1.76609 3.20561 1.78254 3.84467 2.20407 4.2835ZM7.59657 0.509228H9.26762C9.96817 0.552428 10.7972 0.828503 11.246 1.33516L17.6805 8.51873C18.1153 9.0208 18.0976 9.74188 17.6805 10.1706L12.6481 15.203C11.9507 15.5983 11.3115 15.5707 10.881 15.0685L15.8174 10.1321C16.2619 9.64034 16.2144 8.93102 15.8174 8.4995L10.0593 2.05681C9.37768 1.20611 7.91031 0.547628 7.59657 0.509228Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "TagIcon",
  props: {
    color: {
      type: String,
      required: true,
    },
  },
};
</script>
